export const GALLERY_TAB_KEYS = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
};

export const PHOTO_FILE_EXTENSION_REGEX = /\.(jpg|jpeg|png|bmp|tif|tiff|heic|heif)$/i;
export const VIDEO_FILE_EXTENSION_REGEX = /\.(mp4|mov|avi|mkv|flv)$/i;
export const PHOTO_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/tiff',
  'image/heic',
  'image/heif',
]);
export const VIDEO_MIME_TYPES = new Set([
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'video/x-matroska',
  'video/x-flv',
]);
export const PHOTO_FILE_INPUT_ACCEPT =
  '.jpg,.jpeg,.png,.bmp,.tif,.tiff,.heic,.heif,image/jpeg,image/png,image/bmp,image/tiff,image/heic,image/heif';
export const VIDEO_FILE_INPUT_ACCEPT =
  '.mp4,.mov,.avi,.mkv,.flv,video/mp4,video/quicktime,video/x-msvideo,video/x-matroska,video/x-flv';

export const DEFAULT_PHOTO_PLACEHOLDER =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320"%3E%3Cdefs%3E%3ClinearGradient id="bg" x1="0" y1="0" x2="1" y2="1"%3E%3Cstop offset="0%25" stop-color="%23f3f3f3"/%3E%3Cstop offset="1%25" stop-color="%23e7e7e7"/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width="320" height="320" fill="url(%23bg)"/%3E%3Crect x="62" y="86" width="196" height="148" rx="12" fill="none" stroke="%239ca3af" stroke-width="10"/%3E%3Ccircle cx="122" cy="136" r="16" fill="%239ca3af"/%3E%3Cpath d="M84 214l44-44 34 34 24-24 50 34H84z" fill="%239ca3af"/%3E%3C/svg%3E';

export const HEIC_URL_REGEX = /\.(heic|heif)(\?|$)/i;
export const HEIC_MIME_REGEX = /image\/hei[cf]/i;

export const getPhotoMediaUrl = (photo) =>
  photo?.url || photo?.downloadurl || photo?.playbackUrl || '';

export const getPhotoKey = (photo) => photo?.resourceuuid || photo?.downloadurl || photo?.url || '';

export const isHeicPhotoResource = (photo) => {
  const fileHints = `${photo?.filename || ''} ${photo?.url || ''} ${photo?.downloadurl || ''}`;
  const formatHints = `${photo?.format || ''} ${photo?.contentType || ''} ${photo?.metadata?.format || ''}`;

  return HEIC_URL_REGEX.test(fileHints) || HEIC_MIME_REGEX.test(formatHints);
};

export const normalizeHeicConversionResult = (result) => {
  if (Array.isArray(result)) {
    return result[0] || null;
  }

  return result || null;
};

export const convertHeicPhotoToDisplayUrl = async (sourceUrl) => {
  const response = await fetch(sourceUrl);
  if (!response.ok) {
    throw new Error(`Failed to fetch HEIC image: ${response.status}`);
  }

  const sourceBlob = await response.blob();
  const heicModule = await import('heic2any');
  const heic2any = heicModule?.default || heicModule;
  const convertedResult = await heic2any({
    blob: sourceBlob,
    toType: 'image/jpeg',
    quality: 0.9,
  });

  const convertedBlob = normalizeHeicConversionResult(convertedResult);
  if (!(convertedBlob instanceof Blob)) {
    throw new Error('Invalid HEIC conversion result');
  }

  return URL.createObjectURL(convertedBlob);
};

export const RESOURCE_CONFIG = {
  photos: {
    defaultContentType: 'image/jpeg',
    translationPrefix: 'GALLERY_PHOTO_UPLOAD',
    fallbackPreviewText: 'IMG',
  },
  videos: {
    defaultContentType: 'video/mp4',
    translationPrefix: 'GALLERY_VIDEO_UPLOAD',
    fallbackPreviewText: '▶',
  },
};

export const GALLERY_BATCH_SIZE = 15;
export const VIDEO_MP4_EXTENSION_REGEX = /\.mp4(\?|$)/i;
export const VIDEO_PREVIEW_TIMEOUT_MS = 5000;
export const MAX_CHECKSUM_FILE_SIZE_BYTES = 100 * 1024 * 1024;

export const getCountLabel = (count, trans, resourceType) => {
  const prefix = RESOURCE_CONFIG[resourceType].translationPrefix;
  const key = count === 1 ? `${prefix}_FILE_SELECTED_SINGULAR` : `${prefix}_FILE_SELECTED_PLURAL`;
  return trans(key).replace('{{count}}', `${count}`);
};
